import ReportController from './report.controller';

export default class StateReportController extends ReportController
{
	get endpoint() {
		return 'state';
	}

	get title() {
		return 'State Report';
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/state.report.controller.js
 **/